// extracted by mini-css-extract-plugin
export var billingAddress = "_qo-g";
export var contactInfo = "_qo-d";
export var customerInfoContainer = "_qo-c";
export var customerInfoContainerMobile = "_qo-h";
export var customerInfoRow = "_qo-a";
export var customerInfoSection = "_qo-b";
export var fullWidthDividerMobile = "_qo-i";
export var imageContainer = "_qo-1";
export var paymentMethod = "_qo-e";
export var priceText = "_qo-6";
export var priceTextMobile = "_qo-7";
export var product = "_qo-0";
export var productImage = "_qo-2";
export var productInfo = "_qo-4";
export var productMobile = "_qo-9";
export var productTitle = "_qo-8";
export var quantityBadge = "_qo-3";
export var quantityText = "_qo-5";
export var shippingAddress = "_qo-f";